import React, { useState } from 'react';
import { AlertCircleIcon, SearchIcon, FilterIcon, DownloadIcon, CheckCircleIcon, ClockIcon, XCircleIcon, FileTextIcon } from 'lucide-react';
import { formatNaira, formatDate } from '../../utils/format';
export function ClaimsModule({
  role
}: {
  role: string;
}) {
  const [selectedClaim, setSelectedClaim] = useState<any>(null);
  const claims = [{
    id: 'CLM-8492',
    customer: 'Adaeze Okonkwo',
    product: 'AutoGuard',
    underwriter: 'AXA Mansard',
    amount: 500000,
    date: '2026-03-12',
    status: 'Under Review',
    description: 'Accident on 3rd Mainland Bridge, front bumper damaged.'
  }, {
    id: 'CLM-8501',
    customer: 'Chidi Eze',
    product: 'Income Shield',
    underwriter: 'Anchor Insurance',
    amount: 180000,
    date: '2026-03-13',
    status: 'Submitted',
    description: 'Company restructuring, letter of termination attached.'
  }, {
    id: 'CLM-8510',
    customer: 'Ngozi Adeyemi',
    product: 'Wellness Plan',
    underwriter: 'Hygeia HMO',
    amount: 45000,
    date: '2026-03-14',
    status: 'Approved',
    description: 'Outpatient reimbursement for prescribed medication.'
  }, {
    id: 'CLM-7102',
    customer: 'Adaeze Okonkwo',
    product: 'TravelGuard',
    underwriter: 'Cornerstone',
    amount: 120000,
    date: '2026-02-20',
    status: 'Settled',
    description: 'Screen replacement for iPhone 15 Pro.'
  }];
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'Submitted':
        return 'bg-blue-100 text-blue-700';
      case 'Under Review':
      case 'Forwarded':
        return 'bg-amber-100 text-amber-700';
      case 'Approved':
        return 'bg-teal-100 text-teal-700';
      case 'Settled':
        return 'bg-emerald-100 text-emerald-700';
      case 'Rejected':
        return 'bg-rose-100 text-rose-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  };
  return <div className="space-y-6" data-id="element-228">
      <div className="flex justify-between items-center" data-id="element-229">
        <div data-id="element-230">
          <h2 className="text-2xl font-bold text-[#0D3B3B]" data-id="element-231">
            Claims Management
          </h2>
          <p className="text-sm text-gray-500" data-id="element-232">
            Process claims, update statuses, and trigger payouts.
          </p>
        </div>
        {role !== 'Claims Officer' && <button className="bg-white border border-gray-200 text-[#0D3B3B] px-4 py-2 rounded-xl font-bold text-sm flex items-center gap-2 hover:bg-gray-50 transition-colors" data-id="element-233">
            <DownloadIcon className="w-4 h-4" data-id="element-234" /> Export CSV
          </button>}
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden" data-id="element-235">
        <div className="p-4 border-b border-gray-100 flex gap-4" data-id="element-236">
          <div className="relative flex-1" data-id="element-237">
            <SearchIcon className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-238" />
            <input type="text" placeholder="Search by Claim ID, Customer, or Policy..." className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#2BA89D]/20 focus:border-[#2BA89D]" data-id="element-239" />
          </div>
          <button className="px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold text-gray-600 flex items-center gap-2 hover:bg-gray-100" data-id="element-240">
            <FilterIcon className="w-4 h-4" data-id="element-241" /> Filter
          </button>
        </div>

        <div className="overflow-x-auto" data-id="element-242">
          <table className="w-full text-left" data-id="element-243">
            <thead data-id="element-244">
              <tr className="bg-gray-50/50 text-xs uppercase tracking-wider text-gray-500 font-semibold" data-id="element-245">
                <th className="px-6 py-4" data-id="element-246">Claim ID & Date</th>
                <th className="px-6 py-4" data-id="element-247">Customer</th>
                <th className="px-6 py-4" data-id="element-248">Product & Underwriter</th>
                <th className="px-6 py-4" data-id="element-249">Amount</th>
                <th className="px-6 py-4" data-id="element-250">Status</th>
                <th className="px-6 py-4" data-id="element-251">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-252">
              {claims.map(claim => <tr key={claim.id} className="hover:bg-gray-50" data-id="element-253">
                  <td className="px-6 py-4" data-id="element-254">
                    <div className="text-sm font-bold text-[#0D3B3B]" data-id="element-255">
                      {claim.id}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-256">{claim.date}</div>
                  </td>
                  <td className="px-6 py-4 text-sm font-bold text-[#0D3B3B]" data-id="element-257">
                    {claim.customer}
                  </td>
                  <td className="px-6 py-4" data-id="element-258">
                    <div className="text-sm font-bold text-[#0D3B3B]" data-id="element-259">
                      {claim.product}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-260">
                      {claim.underwriter}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm font-bold text-[#0D3B3B]" data-id="element-261">
                    {formatNaira(claim.amount)}
                  </td>
                  <td className="px-6 py-4" data-id="element-262">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-bold ${getStatusBadge(claim.status)}`} data-id="element-263">
                      {claim.status}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-264">
                    <button onClick={() => setSelectedClaim(claim)} className="text-sm font-bold text-[#2BA89D] hover:text-[#0D3B3B]" data-id="element-265">
                      Review
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {/* Claim Detail Modal */}
      {selectedClaim && <div className="fixed inset-0 bg-[#0D3B3B]/40 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-id="element-266">
          <div className="bg-white rounded-3xl w-full max-w-2xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]" data-id="element-267">
            <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50" data-id="element-268">
              <div data-id="element-269">
                <h3 className="font-bold text-[#0D3B3B] text-lg" data-id="element-270">
                  Claim {selectedClaim.id}
                </h3>
                <p className="text-xs text-gray-500" data-id="element-271">
                  {selectedClaim.customer} • {selectedClaim.product}
                </p>
              </div>
              <button onClick={() => setSelectedClaim(null)} className="p-2 hover:bg-gray-200 rounded-full text-gray-500" data-id="element-272">
                <XCircleIcon className="w-6 h-6" data-id="element-273" />
              </button>
            </div>

            <div className="p-6 overflow-y-auto flex-1 space-y-6" data-id="element-274">
              <div className="bg-amber-50 border border-amber-100 rounded-xl p-4" data-id="element-275">
                <h4 className="text-xs font-bold text-amber-800 uppercase tracking-wider mb-2" data-id="element-276">
                  Incident Description
                </h4>
                <p className="text-sm text-amber-900" data-id="element-277">
                  {selectedClaim.description}
                </p>
              </div>

              <div data-id="element-278">
                <h4 className="font-bold text-[#0D3B3B] mb-3" data-id="element-279">
                  Uploaded Documents
                </h4>
                <div className="grid grid-cols-2 gap-3" data-id="element-280">
                  <div className="border border-gray-200 rounded-xl p-3 flex items-center gap-3" data-id="element-281">
                    <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center text-gray-500" data-id="element-282">
                      <FileTextIcon className="w-5 h-5" data-id="element-283" />
                    </div>
                    <div data-id="element-284">
                      <p className="text-sm font-bold text-[#0D3B3B]" data-id="element-285">
                        Police Report.pdf
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-286">1.2 MB</p>
                    </div>
                  </div>
                  <div className="border border-gray-200 rounded-xl p-3 flex items-center gap-3" data-id="element-287">
                    <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center text-gray-500" data-id="element-288">
                      <FileTextIcon className="w-5 h-5" data-id="element-289" />
                    </div>
                    <div data-id="element-290">
                      <p className="text-sm font-bold text-[#0D3B3B]" data-id="element-291">
                        Damage Photos.zip
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-292">4.5 MB</p>
                    </div>
                  </div>
                </div>
              </div>

              <div data-id="element-293">
                <h4 className="font-bold text-[#0D3B3B] mb-3" data-id="element-294">Update Status</h4>
                <select className="w-full bg-gray-50 border border-gray-200 rounded-xl py-3 px-4 text-sm font-bold text-[#0D3B3B] mb-4" data-id="element-295">
                  <option data-id="element-296">{selectedClaim.status}</option>
                  <option data-id="element-297">Submitted</option>
                  <option data-id="element-298">Under Review</option>
                  <option data-id="element-299">Forwarded to Underwriter</option>
                  <option data-id="element-300">Approved</option>
                  <option data-id="element-301">Rejected</option>
                  <option data-id="element-302">Settled</option>
                </select>

                {selectedClaim.status === 'Approved' && (role === 'Super Admin' || role === 'Ops Manager') && <button className="w-full bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-3 rounded-xl transition-colors flex items-center justify-center gap-2 shadow-lg shadow-emerald-500/20" data-id="element-303">
                      <CheckCircleIcon className="w-5 h-5" data-id="element-304" /> Trigger Payout to
                      Wallet ({formatNaira(selectedClaim.amount)})
                    </button>}
              </div>
            </div>
          </div>
        </div>}
    </div>;
}